// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'C:/BusOneDevManaged/mng_front_sample_1/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from 'C:/BusOneDevManaged/mng_front_sample_1/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import StarOutlined from 'C:/BusOneDevManaged/mng_front_sample_1/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/StarOutlined';
import BankOutlined from 'C:/BusOneDevManaged/mng_front_sample_1/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BankOutlined';
export default { SmileOutlined, UserOutlined, StarOutlined, BankOutlined };
